import { StyledButtonWithStates } from '../../components/global/Global.style';

const defaultColor = 'red';

const defaultStyle = {
  width: '100%',
  height: '2.9rem'
};

function CardPaymentButton({
  children,
  type = 'submit',
  color = defaultColor,
  style = {},
  testId,
  ...rest
}: React.PropsWithChildren<{
  type?: 'button' | 'submit',
  disabled?: boolean,
  onClick?: () => void,
  color?: string,
  style?: object,
  testId?: string,
}>) {
  return (
    <StyledButtonWithStates
      type={type}
      color={color}
      style={{ ...defaultStyle, ...style }}
      {...rest}
      fullWidth
      data-test={testId}
    >
      {children}
    </StyledButtonWithStates>
  );
}

export default CardPaymentButton;
